import React from "react";
import Walltilebnr from "../../assets/HomeImages/WallTiles.png";
import summersalebnr from "../../assets/HomeImages/SummerSale.png";
import floortilesbnr from "../../assets/HomeImages/FloorTiles.png";

const Banners = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 px-4 sm:px-6 lg:px-8 py-4">
      <div className="lg:col-span-2">
        <img
          src={Walltilebnr}
          alt="Wall Tiles"
          className="w-full h-full object-cover rounded-xl"
        />
      </div>

      <div className="flex flex-col gap-4">
        <div>
          <img
            src={summersalebnr}
            alt="Summer Sale"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>

        <div className="relative">
          <img
            src={floortilesbnr}
            alt="Floor Tiles Deal"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>
      </div>
    </div>
  );
};

export default Banners;
